import { ArrowLeft, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FAQSection } from '@/components/FAQSection';
import { useNavigate } from 'react-router-dom';

export function FAQPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* Header s návratem */}
        <div className="mb-6">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="mb-4 hover:bg-muted"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zpět
          </Button>
          
          <div className="text-center">
            <div className="flex items-center justify-center gap-3 mb-2">
              <HelpCircle className="h-8 w-8 text-primary" />
              <h1 className="text-3xl font-bold tracking-tight">
                Často kladené otázky
              </h1>
            </div>
            <p className="text-lg text-muted-foreground">
              Odpovědi na nejčastější dotazy týkající se kamen BLAZE HARMONY
            </p>
          </div>
        </div>

        {/* FAQ obsah */}
        <Card>
          <CardHeader>
            <CardTitle className="text-center">
              Kompletní přehled FAQ pro obchodníky
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <FAQSection />
          </CardContent>
        </Card>

      </div>
    </div>
  );
}